var UploadErrorCode = /* @__PURE__ */ function(UploadErrorCode2) {
  UploadErrorCode2["FileTooLarge"] = "FILE_TOO_LARGE";
  UploadErrorCode2["FileUploadFailed"] = "FILE_UPLOAD_FAILED";
  UploadErrorCode2["FileUploadCancelled"] = "FILE_UPLOAD_CANCELLED";
  UploadErrorCode2["FileTreeTooDeep"] = "FILE_TREE_TOO_DEEP";
  UploadErrorCode2["QuotaExceeded"] = "QUOTA_EXCEEDED";
  UploadErrorCode2["UploadTaskMissing"] = "UPLOAD_TASK_MISSING";
  UploadErrorCode2["UploadChunkMissing"] = "UPLOAD_CHUNK_MISSING";
  UploadErrorCode2["FileNotAvailable"] = "FILE_NOT_AVAILABLE";
  UploadErrorCode2["TaskMissingResult"] = "TASK_MISSING_RESULT";
  UploadErrorCode2["ChunkMissingLink"] = "CHUNK_MISSING_LINK";
  UploadErrorCode2["Timeout"] = "TIMEOUT";
  UploadErrorCode2["Unknown"] = "UNKNOWN";
  return UploadErrorCode2;
}({});
var UploadTaskStatus = /* @__PURE__ */ function(UploadTaskStatus2) {
  UploadTaskStatus2["Pending"] = "pending";
  UploadTaskStatus2["Uploading"] = "uploading";
  UploadTaskStatus2["Completed"] = "completed";
  UploadTaskStatus2["Failed"] = "failed";
  return UploadTaskStatus2;
}({});
var UploadTaskPriority = /* @__PURE__ */ function(UploadTaskPriority2) {
  UploadTaskPriority2[UploadTaskPriority2["Low"] = 0] = "Low";
  UploadTaskPriority2[UploadTaskPriority2["Medium"] = 1] = "Medium";
  UploadTaskPriority2[UploadTaskPriority2["Instant"] = 2] = "Instant";
  return UploadTaskPriority2;
}({});
var NoAvailabilityReason = /* @__PURE__ */ function(NoAvailabilityReason2) {
  NoAvailabilityReason2["MAX_FILES"] = "MAX_FILES";
  NoAvailabilityReason2["MAX_CHUNKS"] = "MAX_CHUNKS";
  NoAvailabilityReason2["LOW_PRIORITY"] = "LOW_PRIORITY";
  NoAvailabilityReason2["TASK_NOT_FOUND"] = "TASK_NOT_FOUND";
  return NoAvailabilityReason2;
}({});

export { NoAvailabilityReason, UploadErrorCode, UploadTaskPriority, UploadTaskStatus };
//# sourceMappingURL=index.js.map
